import { useEffect, useState } from 'react'

import { setStorageSerializedItem } from '../../../../../utils/storage'
import { readBirdviewStorageItem } from '../../../DashboardBirdview.utils.storage'
import { checkIsBirdviewChartGridSpans } from '../../BirdviewChartGrid.utils'

export function useBirdviewChartGridSpans({ defaultSpans, storageKey }) {
  const [spans, setSpans] = useState(() => ({
    ...defaultSpans,
    ...readBirdviewStorageItem(storageKey, checkIsBirdviewChartGridSpans),
  }))

  useEffect(() => {
    setStorageSerializedItem(storageKey, spans)
  }, [spans, storageKey])

  function setSpan(id, span) {
    setSpans(prev => (prev[id] === span ? prev : { ...prev, [id]: span }))
  }

  return { setSpan, spans }
}
